<template>
  <v-dialog transition="dialog-top-transition" max-width="90%" persistent v-model="dialog_baixa">
    <template v-slot:default="">
      <v-card>
        <!-- Header -->
        <div class="dialog-header">
          <div class="dialog-header__icon-wrap">
            <v-icon color="#0052A0">mdi-eraser</v-icon>
          </div>
          <div>
            <div class="dialog-header__title">Solicitação de Baixa</div>
            <div class="dialog-header__sub">Confirme os protocolos e informe sua senha</div>
          </div>
          <v-spacer></v-spacer>
          <!-- Senha inline no header -->
          <div class="senha-wrap">
            <v-text-field
              v-model="senha"
              prepend-inner-icon="mdi-lock-outline"
              type="password"
              label="Sua senha"
              outlined dense color="#0052A0"
              hide-details
              style="max-width:220px"
            />
          </div>
        </div>

        <!-- Tabela -->
        <v-card-text class="pa-6">
          <div class="table-wrap">
            <v-simple-table dense class="baixa-confirm-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nome</th>
                    <th>CPF/CNPJ</th>
                    <th>Lote</th>
                    <th>Protocolo</th>
                    <th>Nº Título</th>
                    <th>Data Emissão</th>
                    <th>Data Vencimento</th>
                    <th>Valor Original</th>
                    <th>Valor Vencido</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in visualizacao" :key="item.protocolo">
                    <td>{{ item.index }}</td>
                    <td>{{ item.cliente.name }}</td>
                    <td>{{ formatarCpfCnpj(item.cliente.cpf_cnpj) }}</td>
                    <td>{{ item.lote }}</td>
                    <td class="cell-mono">{{ item.protocolo }}</td>
                    <td>{{ item.numero_titulo }}</td>
                    <td>{{ converterDataTimestamp(item.data_emissao) }}</td>
                    <td>{{ converterDataTimestamp(item.data_vencimento) }}</td>
                    <td>{{ converterDinherio(item.valor_original) }}</td>
                    <td>{{ converterDinherio(item.valor_vencido) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card-text>

        <!-- Ações -->
        <v-card-actions style="border-top:1px solid #f1f5f9;padding:14px 20px;">
          <v-spacer></v-spacer>
          <v-btn text rounded color="grey darken-1" @click="$emit('close')" class="mr-2">
            <v-icon left small>mdi-close</v-icon>Fechar
          </v-btn>
          <v-btn color="#0052A0" rounded elevation="0" :disabled="save" @click="solicitarBaixa" class="px-8">
            <v-icon left color="#FFD400" small>mdi-eraser</v-icon>
            <span style="color:#FFD400;font-weight:700;font-size:13px">Solicitar Baixa</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import helper from "../mixins/helper";

export default {
  name: "BaixaComponent",
  mixins: [helper],
  props: {
    visualizacao: { default: [] },
    protocolo: { default: '' },
    dialog_baixa: { default: false },
    motivos: { default: [] },
  },
  data: () => ({
    senha: null,
    save: true,
    motivo_observacao: null,
    motivo: null,
    dadosEnvio: { negativacoes: {} },
    headers_log: [
      { text: 'Data/Hora', value: 'data', align: 'start' },
      { text: 'Usuario', value: 'name', align: 'center' },
      { text: 'IP', value: 'user_ip', align: 'center' },
      { text: 'Transação', value: 'transacao', align: 'center' },
      { text: 'Ação', value: 'acao', align: 'center' },
      { text: 'Motivo', value: 'motivo', align: 'center' },
      { text: 'Observação', value: 'observacao', width: "15%", align: 'center' },
      { text: 'Status', value: 'status_nome', width: "15%", align: 'center' },
    ],
  }),
  watch: {
    senha(newValue) {
      this.save = !(newValue && newValue.length >= 8);
    }
  },
  methods: {
    fecharAtualizar() {
      this.senha = null;
      this.$emit('close');
      this.$emit('atualizar');
    },
    solicitarBaixa() {
      this.$http.post("protocolos/baixa", { dados: this.visualizacao, senha: this.senha }).then(
        (response) => {
          this.notificarPopupCallback(this, response.body.message, 'success', this.fecharAtualizar);
        },
        (response) => {
          this.notificar(this, 'Desculpe', response.body.message);
        }
      );
    }
  },
};
</script>

<style scoped>
/* ─── Dialog header ─────────────────────────────────── */
.dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
  flex-wrap: wrap;
}
.dialog-header__icon-wrap {
  width: 36px; height: 36px;
  background: #e8f0fe;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.dialog-header__title {
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1e293b;
}
.dialog-header__sub {
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: #94a3b8;
  margin-top: 2px;
}
.senha-wrap {
  flex-shrink: 0;
}

/* ─── Tabela ─────────────────────────────────────────── */
.table-wrap {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}
.baixa-confirm-table >>> th {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  color: #64748b !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #f8fafc !important;
  padding: 10px 10px !important;
  white-space: nowrap;
}
.baixa-confirm-table >>> td {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.85rem !important;
  color: #1e293b !important;
  font-weight: 400 !important;
  padding: 10px 10px !important;
  border-bottom: 1px solid #f1f5f9 !important;
}
.cell-mono {
  font-size: 0.72rem !important;
  color: #64748b !important;
}
</style>
